export enum ShiftType {
  MORNING = "Morning Shift",
  AFTERNOON = "Afternoon Shift",
  NIGHT = "Night Shift",
}
export const ShiftAbbreviation: Record<ShiftType, string> = {
  [ShiftType.MORNING]: "MS",
  [ShiftType.AFTERNOON]: "AS",
  [ShiftType.NIGHT]: "NS",
};
export enum ShiftTypePanorama {
  DAILY_WAGE = "DAILY_WAGE",
  TEMPORARY_HELP = "TEMPORARY_HELP",
  HOURS = "HOURS",
  LEAVES = "LEAVES",
}
export const ShiftPanoramaAbbreviation: Record<ShiftTypePanorama, string> = {
  [ShiftTypePanorama.DAILY_WAGE]: "DW",
  [ShiftTypePanorama.TEMPORARY_HELP]: "TH",
  [ShiftTypePanorama.HOURS]: "HRS",
  [ShiftTypePanorama.LEAVES]: "LV",
};

export enum DayOfWeek {
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
}
